'use strict';

/**
 * library
 */
import 'slick-carousel';

/**
 * module
 */

/**
 * homeheader
 */
export const slider = (() => {
    const $carousel_01 = $('.js-slide-01');
    const $carousel_02 = $('.js-slide-02');
    const $carousel_03 = $('.js-slide-03');

    const w = parseInt($('body').width());
    let maxHeight = 0;
    const breakPoint = 769;

    const init = () => {
        $(document).ready(() => {
            slicks();
            slideHeight03();

            $(window).on('resize', () => {
                setTimeout(() => {
                    slicks();
                }, 100);
                setTimeout(function() {
                    slideHeight();
                    slideHeight03();
                }, 100);
            });

            $('.js-slide-set').on('click', () => {
                setTimeout(function() {
                    $carousel_01.slick('setPosition');
                    $carousel_02.slick('setPosition');
                }, 100);
                setTimeout(function() {
                    slideHeight();
                }, 100);
            });

            $('#sec03 .slide-arrow, .box-content--03, .slick-dots').on('click touchstart', () => {
                setTimeout(function() {
                    slideHeight03();
                }, 100);
            });
        });
    };

    const slicks = () => {
        $carousel_01.not('.slick-initialized').slick({
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        autoplay: false,
                        infinite: false,
                        swipe: true,
                        draggable: true,
                        arrows: true,
                        dots: true,
                        prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                        nextArrow: '<div class="slide-arrow next-arrow"></div>'
                    }
                },
                {
                    breakpoint: 999999,
                    settings: 'unslick'
                }
            ]
        });

        $carousel_02.not('.slick-initialized').slick({
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        autoplay: false,
                        infinite: false,
                        swipe: true,
                        draggable: true,
                        arrows: true,
                        dots: true,
                        prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                        nextArrow: '<div class="slide-arrow next-arrow"></div>'
                    }
                },
                {
                    breakpoint: 999999,
                    settings: 'unslick'
                }
            ]
        });

        $carousel_03.not('.slick-initialized').slick({
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        autoplay: false,
                        infinite: false,
                        swipe: true,
                        draggable: true,
                        arrows: true,
                        dots: true,
                        prevArrow: '<div class="slide-arrow prev-arrow"></div>',
                        nextArrow: '<div class="slide-arrow next-arrow"></div>'
                    }
                },
                {
                    breakpoint: 999999,
                    settings: 'unslick'
                }
            ]
        });
    };

    const slideHeight = () => {
        if (w < breakPoint) {
            $carousel_01.find('.list-detail__item').each((index, element) => {
                const $this = $(element);

                if (index === 0) {
                    maxHeight = $this.height();
                } else if (index === 1) {
                    $this.height(maxHeight);
                }
            });

            $carousel_02.find('.list-detail__item').each((index, element) => {
                const $this = $(element);

                if (index === 0) {
                    maxHeight = $this.height();
                } else if (index === 1) {
                    $this.height(maxHeight);
                }
            });
        }else{
            $carousel_01.find('img').each((index, element) => {
                const $this = $(element);
                $this.css('opacity', '1');
            });
            $carousel_02.find('img').each((index, element) => {
                const $this = $(element);
                $this.css('opacity', '1');
            });
        }
    };

    const slideHeight03 = () => {
        if (w < breakPoint) {
            $carousel_03.find('.box-content--03').each((index, element) => {
                const $this = $(element);

                if (index === 0) {
                    maxHeight = $this.height();
                } else if (index === 1) {
                    $this.height(maxHeight);
                }
            });
        } else {
            $carousel_03.find('.box-content--03').each((index, element) => {
                const $this = $(element);
                $this.height('auto');
            });
            $carousel_03.find('img').each((index, element) => {
                const $this = $(element);
                $this.css('opacity', '1');
            });
        }
    };

    return {
        init: init
    };
})();
